var _circle, _circle2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToCartBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.8867,
    cy: 39.2139,
    r: 38.625,
    fill: "#222222"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.8867,
    cy: 39.2139,
    r: 38.625,
    fill: "black",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3867 35.2139C36.2151 35.2139 36.8867 34.5423 36.8867 33.7139C36.8867 32.8854 36.2151 32.2139 35.3867 32.2139C34.5583 32.2139 33.8867 32.8854 33.8867 33.7139C33.8867 34.5423 34.5583 35.2139 35.3867 35.2139Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3867 35.2139C45.2151 35.2139 45.8867 34.5423 45.8867 33.7139C45.8867 32.8854 45.2151 32.2139 44.3867 32.2139C43.5583 32.2139 42.8867 32.8854 42.8867 33.7139C42.8867 34.5423 43.5583 35.2139 44.3867 35.2139Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8867 20.2139H32.8867L33.4867 23.2139M33.4867 23.2139L34.8867 30.2139H44.8867L46.8867 23.2139H33.4867Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5747 44.4979H35.9027V52.6899H34.5747V44.4979ZM35.5347 48.0339H38.0467V49.1219H35.5347V48.0339ZM25.3427 50.7699H26.4627C29.4387 50.7699 31.1187 50.6899 33.0547 50.2899L33.1987 51.3779C31.2147 51.7779 29.5027 51.8739 26.4627 51.8739H25.3427V50.7699ZM25.3427 45.4579H31.7107V46.5459H26.6547V51.3939H25.3427V45.4579ZM26.8147 53.4579H35.9027V58.7699H26.8147V53.4579ZM34.6067 54.5299H28.1107V57.6819H34.6067V54.5299ZM49.9335 44.4979H51.2615V58.9619H49.9335V44.4979ZM45.6935 46.0499H47.0055C47.0055 50.2419 45.1175 53.9059 40.2855 56.2739L39.5815 55.2019C43.7575 53.1859 45.6935 50.1139 45.6935 46.2739V46.0499ZM40.2375 46.0499H46.2695V47.1379H40.2375V46.0499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCartBtn);
export default __webpack_public_path__ + "static/media/add_to_cart_btn.82ce7f3c9042cc82c6cf2f50f9c79c9f.svg";
export { ForwardRef as ReactComponent };